var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',[_c('div',{ref:"mains",staticClass:"LGraphCard"}),(_vm.first>0 && _vm.item.data.length == 0)?_c('LEmpty'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }